import DeleteOutlineIcon from '@mui/icons-material/DeleteOutlined';
import DownloadIcon from '@mui/icons-material/Download';
import { Box } from '@mui/material';

import Button from '@/components/Buttons/Button';
import { DATAHUB_ACTION_BUTTON_WIDTH } from '@/features/DataHub/constants/ui';

const rootSx = {
  display: 'flex',
  gap: 2,
  alignItems: 'center',
  justifyContent: 'space-between',
  mt: 2
};
const deleteBtnSx = { width: DATAHUB_ACTION_BUTTON_WIDTH };
const regenerateBtnSx = {
  width: DATAHUB_ACTION_BUTTON_WIDTH,
  '&.Mui-disabled': { backgroundColor: 'text.disabled', color: 'gx.neutral' }
};

export const ExportItemActions = ({
  canDelete,
  canRegenerate,
  isDeleting,
  onDelete,
  onRegenerate
}: {
  canDelete: boolean;
  canRegenerate: boolean;
  isDeleting: boolean;
  onDelete: () => void;
  onRegenerate: () => void;
}) => {
  return (
    <Box sx={rootSx}>
      <Button
        disabled={!canDelete || isDeleting}
        size='small'
        startIcon={<DeleteOutlineIcon />}
        sx={deleteBtnSx}
        variant='outlined'
        onClick={onDelete}
      >
        Delete
      </Button>
      <Button
        disabled={!canRegenerate || isDeleting}
        size='small'
        startIcon={<DownloadIcon />}
        sx={regenerateBtnSx}
        variant='contained'
        onClick={onRegenerate}
      >
        Regenerate
      </Button>
    </Box>
  );
};
